import React, { FC } from 'react'
import './ssce.scss'

interface dataTypes {
    register: any
    errors: any
    handleChange: (value: any) => void
    values: any
}

const SSCE: FC<dataTypes> = ({ register, errors, handleChange, values }) => {
  const dashroute = localStorage.getItem('__userRole')
  const isOfficer = dashroute === 'pscreen_officer'
  return (
        <div className="ssce-modern">
            <div className="form-card">
                <div className="form-card-header">
                    <div className="header-icon">
                        <i className="fa fa-graduation-cap"></i>
                    </div>
                    <h3 className="header-title">SSCE Details</h3>
                </div>
                <div className="form-card-body">
                {isOfficer
                  ? <div className="container-fluid">
                    {(values?.sscedetails?.[0]?.examYear) &&
                        (<div className="row justify-content-between">
                               <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam Year <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' readOnly {...register('examYear', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.examYear && <span className="text-danger">{errors.examYear.message}</span>}
                            </div>
                            <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam Type <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' readOnly {...register('examType', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.examType && <span className='text-danger'>{errors.examType.message}</span>}
                            </div>
                            <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam No <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' readOnly {...register('examNo', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.examNo && <span className='text-danger'>{errors.examNo.message}</span>}
                            </div>

                        </div>
                        )
                    }
                    {values?.sscedetails?.[0]?.examYear &&
                    <>
                    <h5 className='mt-3'>Subject & Grade</h5>
                         <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 1 <span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject1', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject1 && <span className='text-danger'>{errors.subject1.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 1 <span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade1', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade1 && <span className='text-danger'>{errors.grade1.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 2<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject2', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject2 && <span className='text-danger'>{errors.subject2.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 2<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade2', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade2 && <span className='text-danger'>{errors.grade2.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 3 <span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject3', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject3 && <span className='text-danger'>{errors.subject3.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 3<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade3', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade3 && <span className='text-danger'>{errors.grade3.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 4<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject4', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject4 && <span className='text-danger'>{errors.subject4.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 4<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade4', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade4 && <span className='text-danger'>{errors.grade4.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 5<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject5', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject5 && <span className='text-danger'>{errors.subject5.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 5<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade5', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade5 && <span className='text-danger'>{errors.grade5.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 6<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject6', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject6 && <span className='text-danger'>{errors.subject6.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 6<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade6', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade6 && <span className='text-danger'>{errors.grade6.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 7<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject7', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject7 && <span className='text-danger'>{errors.subject7.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 7<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade7', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade7 && <span className='text-danger'>{errors.grade7.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 8<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject8', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject8 && <span className='text-danger'>{errors.subject8.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 8<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade8', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade8 && <span className='text-danger'>{errors.grade8.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 9<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject9', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject9 && <span className='text-danger'>{errors.subject9.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 9<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade9', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade9 && <span className='text-danger'>{errors.grade9.message}</span>}
                         </div>
                     </div>
</>
                    }
                     {(values?.sscedetails?.[1]?.examYear) &&
                        (<div className="row justify-content-between">
                               <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam Year <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' readOnly {...register('oneexamYear', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.oneexamYear && <span className="text-danger">{errors.oneexamYear.message}</span>}
                            </div>
                            <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam Type <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' readOnly {...register('oneexamType', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.oneexamType && <span className='text-danger'>{errors.oneexamType.message}</span>}
                            </div>
                            <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Email <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' readOnly {...register('oneexamNo', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.oneexamNo && <span className='text-danger'>{errors.oneexamNo.message}</span>}
                            </div>

                        </div>
                        )
                    }
                      {values?.sscedetails?.[1]?.examYear &&
                    <>
                    <h5 className='mt-3'>Subject & Grade</h5>
                         <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 1 <span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('twosubject1', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject1 && <span className='text-danger'>{errors.twosubject1.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 1 <span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('twograde1', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde1 && <span className='text-danger'>{errors.twograde1.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 2<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('twosubject2', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject2 && <span className='text-danger'>{errors.twosubject2.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 2<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('twograde2', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde2 && <span className='text-danger'>{errors.twograde2.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 3 <span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('twosubject3', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject3 && <span className='text-danger'>{errors.twosubject3.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 3<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('twograde3', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde3 && <span className='text-danger'>{errors.twograde3.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 4<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('twosubject4', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject4 && <span className='text-danger'>{errors.twosubject4.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 4<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('twograde4', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde4 && <span className='text-danger'>{errors.twograde4.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 5<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('twosubject5', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject5 && <span className='text-danger'>{errors.twosubject5.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 5<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('twograde5', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde5 && <span className='text-danger'>{errors.twograde5.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 6<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('twosubject6', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject6 && <span className='text-danger'>{errors.twosubject6.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 6<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('twograde6', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde6 && <span className='text-danger'>{errors.twograde6.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 7<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject7', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject7 && <span className='text-danger'>{errors.subject7.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 7<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('grade7', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade7 && <span className='text-danger'>{errors.grade7.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 8<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('twosubject8', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject8 && <span className='text-danger'>{errors.twosubject8.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 8<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('twograde8', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde8 && <span className='text-danger'>{errors.twograde8.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 9<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' readOnly {...register('subject9', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twograde9 && <span className='text-danger'>{errors.twograde9.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 9<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' readOnly {...register('twograde9', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde9 && <span className='text-danger'>{errors.twograde9.message}</span>}
                         </div>
                     </div>
</>
                    }
                    </div>
                  : <div className="container-fluid">
                    {(values?.sscedetails?.[0]?.examYear) &&
                        (<div className="row justify-content-between">
                               <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam Year <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' {...register('examYear', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.examYear && <span className="text-danger">{errors.examYear.message}</span>}
                            </div>
                            <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam Type <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' {...register('examType', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.examType && <span className='text-danger'>{errors.examType.message}</span>}
                            </div>
                            <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam No <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' {...register('examNo', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.examNo && <span className='text-danger'>{errors.examNo.message}</span>}
                            </div>

                        </div>
                        )
                    }
                    {values?.sscedetails?.[0]?.examYear &&
                    <>
                    <h5 className='mt-3'>Subject & Grade</h5>
                         <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 1 <span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject1', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject1 && <span className='text-danger'>{errors.subject1.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 1 <span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade1', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade1 && <span className='text-danger'>{errors.grade1.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 2<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject2', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject2 && <span className='text-danger'>{errors.subject2.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 2<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade2', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade2 && <span className='text-danger'>{errors.grade2.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 3 <span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject3', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject3 && <span className='text-danger'>{errors.subject3.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 3<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade3', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade3 && <span className='text-danger'>{errors.grade3.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 4<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject4', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject4 && <span className='text-danger'>{errors.subject4.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 4<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade4', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade4 && <span className='text-danger'>{errors.grade4.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 5<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject5', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject5 && <span className='text-danger'>{errors.subject5.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 5<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade5', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade5 && <span className='text-danger'>{errors.grade5.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 6<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject6', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject6 && <span className='text-danger'>{errors.subject6.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 6<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade6', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade6 && <span className='text-danger'>{errors.grade6.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 7<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject7', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject7 && <span className='text-danger'>{errors.subject7.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 7<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade7', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade7 && <span className='text-danger'>{errors.grade7.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 8<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject8', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject8 && <span className='text-danger'>{errors.subject8.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 8<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade8', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade8 && <span className='text-danger'>{errors.grade8.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 9<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject9', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject9 && <span className='text-danger'>{errors.subject9.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 9<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade9', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade9 && <span className='text-danger'>{errors.grade9.message}</span>}
                         </div>
                     </div>
</>
                    }
                     {(values?.sscedetails?.[1]?.examYear) &&
                        (<div className="row justify-content-between">
                               <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam Year <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' {...register('oneexamYear', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.oneexamYear && <span className="text-danger">{errors.oneexamYear.message}</span>}
                            </div>
                            <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Exam Type <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' {...register('oneexamType', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.oneexamType && <span className='text-danger'>{errors.oneexamType.message}</span>}
                            </div>
                            <div className='col-lg-4 col-md-12 col-sm-12'>
                                <label>Email <span className="text-danger">*</span></label>
                                <input type={'text'} className='form-control' {...register('oneexamNo', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.oneexamNo && <span className='text-danger'>{errors.oneexamNo.message}</span>}
                            </div>

                        </div>
                        )
                    }
                      {values?.sscedetails?.[1]?.examYear &&
                    <>
                    <h5 className='mt-3'>Subject & Grade</h5>
                         <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 1 <span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('twosubject1', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject1 && <span className='text-danger'>{errors.twosubject1.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 1 <span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('twograde1', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde1 && <span className='text-danger'>{errors.twograde1.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 2<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('twosubject2', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject2 && <span className='text-danger'>{errors.twosubject2.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 2<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('twograde2', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde2 && <span className='text-danger'>{errors.twograde2.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 3 <span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('twosubject3', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject3 && <span className='text-danger'>{errors.twosubject3.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 3<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('twograde3', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde3 && <span className='text-danger'>{errors.twograde3.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 4<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('twosubject4', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject4 && <span className='text-danger'>{errors.twosubject4.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 4<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('twograde4', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde4 && <span className='text-danger'>{errors.twograde4.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 5<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('twosubject5', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject5 && <span className='text-danger'>{errors.twosubject5.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 5<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('twograde5', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde5 && <span className='text-danger'>{errors.twograde5.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 6<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('twosubject6', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject6 && <span className='text-danger'>{errors.twosubject6.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 6<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('twograde6', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde6 && <span className='text-danger'>{errors.twograde6.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 7<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject7', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.subject7 && <span className='text-danger'>{errors.subject7.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 7<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('grade7', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.grade7 && <span className='text-danger'>{errors.grade7.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 8<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('twosubject8', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twosubject8 && <span className='text-danger'>{errors.twosubject8.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 8<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('twograde8', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde8 && <span className='text-danger'>{errors.twograde8.message}</span>}
                         </div>
                     </div>
                     <div className='row'>
                         <div className='col-lg-4 col-md-12  col-sm-12'>
                             <label>Subject 9<span className="text-danger">*</span></label>

                             <input type={'text'} className='form-control' {...register('subject9', { required: 'Please fill the field' })} onChange={handleChange} />
                                {errors.twograde9 && <span className='text-danger'>{errors.twograde9.message}</span>}

                         </div>
                         <div className='col-lg-4 col-md-12 col-sm-12'>
                             <label>Grade 9<span className="text-danger">*</span></label>
                             <input type={'text'} className='form-control' {...register('twograde9', { required: 'Please fill the field' })} onChange={handleChange} />
                             {errors.twograde9 && <span className='text-danger'>{errors.twograde9.message}</span>}
                         </div>
                     </div>
</>
                    }
                    </div>
                    }
                </div>
            </div>
        </div>
  )
}

export default SSCE
